var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSccHigh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2,
    fill: "#EA4335"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88029 14.9858H7.4941L7.38619 6.31173H8.9965L8.88029 14.9858ZM7.32809 17.6254C7.32809 17.3764 7.40279 17.1689 7.5522 17.0028C7.70715 16.8313 7.93403 16.7455 8.23285 16.7455C8.53167 16.7455 8.75855 16.8313 8.9135 17.0028C9.06844 17.1689 9.14591 17.3764 9.14591 17.6254C9.14591 17.8744 9.06844 18.0819 8.9135 18.2479C8.75855 18.4084 8.53167 18.4886 8.23285 18.4886C7.93403 18.4886 7.70715 18.4084 7.5522 18.2479C7.40279 18.0819 7.32809 17.8744 7.32809 17.6254ZM13.263 14.9858H11.8768L11.7689 6.31173H13.3792L13.263 14.9858ZM11.7108 17.6254C11.7108 17.3764 11.7855 17.1689 11.9349 17.0028C12.0898 16.8313 12.3167 16.7455 12.6155 16.7455C12.9144 16.7455 13.1412 16.8313 13.2962 17.0028C13.4511 17.1689 13.5286 17.3764 13.5286 17.6254C13.5286 17.8744 13.4511 18.0819 13.2962 18.2479C13.1412 18.4084 12.9144 18.4886 12.6155 18.4886C12.3167 18.4886 12.0898 18.4084 11.9349 18.2479C11.7855 18.0819 11.7108 17.8744 11.7108 17.6254ZM17.6457 14.9858H16.2595L16.1516 6.31173H17.7619L17.6457 14.9858ZM16.0935 17.6254C16.0935 17.3764 16.1682 17.1689 16.3176 17.0028C16.4725 16.8313 16.6994 16.7455 16.9982 16.7455C17.2971 16.7455 17.5239 16.8313 17.6789 17.0028C17.8338 17.1689 17.9113 17.3764 17.9113 17.6254C17.9113 17.8744 17.8338 18.0819 17.6789 18.2479C17.5239 18.4084 17.2971 18.4886 16.9982 18.4886C16.6994 18.4886 16.4725 18.4084 16.3176 18.2479C16.1682 18.0819 16.0935 17.8744 16.0935 17.6254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSccHigh);
export default __webpack_public_path__ + "static/media/scc_High.a4e7d761667fcb8a6a006e96af0410ae.svg";
export { ForwardRef as ReactComponent };